import {StringParamLanguage} from '../../../../../../@polygonjs/polygonjs/src/engine/params/utils/OptionsController';
import {isString} from '../../../../../../@polygonjs/polygonjs/src/core/Type';
import * as monaco from 'monaco-editor';
export const MonacoCommonOptions: monaco.editor.IStandaloneEditorConstructionOptions = {
	renderWhitespace: 'boundary',
	theme: 'vs-dark', // 'hc-black', // vs-dark // not sure why only the minimap gets the theme
	insertSpaces: false,
	tabSize: 4,
	automaticLayout: true, // auto resize (https://stackoverflow.com/questions/47017753/monaco-editor-dynamically-resizable)
};

export function updateMonacoEditorModel(content: string, model: monaco.editor.ITextModel | null) {
	if (model) {
		if (isString(content)) {
			model.setValue(content);
		}
	} else {
		console.warn('no model to update');
	}
}
export function monacoEditorCreateModel(rawInput: string, language: StringParamLanguage, editorId: string) {
	const uri = monaco.Uri.parse(`file:///${language}-${editorId}.tsx`);
	let model = monaco.editor.getModel(uri);
	if (!model) {
		model = monaco.editor.createModel(rawInput, language, uri);
	} else {
		model.setValue(rawInput);
	}
	return model;
}
